/**
 *  @class
 *  @function FacetsToggle
 */
if (!customElements.get('facets-toggle')) {
  class FacetsToggle extends HTMLElement {
    connectedCallback() {
      this.drawer = document.getElementById('Facet-Drawer');

      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (OverlayManager.isOpen(this.drawer)) {
          OverlayManager.close(this.drawer);
        } else {
          OverlayManager.open(this.drawer);
        }
      });

      setTimeout(() => {
        window.dispatchEvent(new Event('resize.resize-select'));
      }, 10);
    }
  }
  customElements.define('facets-toggle', FacetsToggle);
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    FacetFiltersForm.publishFacetUpdate(searchParams);
  }

  // shopify:collection:update / shopify:search:update — filters or sort changed
  static publishFacetUpdate(searchParams) {
    const SE = window.Shopify && window.Shopify.StandardEvents;
    if (!SE) return;
    const params = new URLSearchParams(searchParams);

    if (theme.settings.collection_id) {
      publishStandardEvent('CollectionUpdateEvent', {
        collection: { id: theme.settings.collection_id },
        filters: SE.CollectionUpdateEvent.parseProductFilters(params),
        sortKey: SE.CollectionUpdateEvent.getSortKey(params)
      });
    } else if (window.location.pathname.indexOf(theme.routes.search_url) !== -1) {
      publishStandardEvent('SearchUpdateEvent', {
        searchTerm: params.get('q') || new URLSearchParams(window.location.search).get('q') || '',
        filters: SE.SearchUpdateEvent.parseProductFilters(params),
        sortKey: SE.SearchUpdateEvent.getSortKey(params)
      });
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        withViewTransition(() => {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    withViewTransition(() => {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row, #FacetFiltersForm-bar collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      const sourceFormId = element.closest('form')?.id;
      const targetFormId = jsFilter?.closest('form')?.id;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index && sourceFormId === targetFormId
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const formId = element.closest('form')?.id;
      const targetForm = formId ? document.getElementById(formId) : null;
      const target = targetForm?.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`);
      if (target) target.replaceWith(element);
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-filter-count',
      '.mobile-filters-apply-label',
      '.facets-toggle-count'
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    const currentSearchParams = new URLSearchParams(window.location.search);
    const availabilityInput = form.querySelector(
      'input[type="checkbox"][name="filter.v.availability"]'
    );

    if (availabilityInput) {
      if (availabilityInput.checked) {
        searchParams.delete(FacetFiltersForm.availabilityOptOutParam);
      } else {
        searchParams.delete(FacetFiltersForm.availabilityParam);
        searchParams.set(FacetFiltersForm.availabilityOptOutParam, '1');
      }
    } else if (currentSearchParams.get(FacetFiltersForm.availabilityOptOutParam) === '1') {
      searchParams.set(FacetFiltersForm.availabilityOptOutParam, '1');
    } else if (
      currentSearchParams.has(FacetFiltersForm.availabilityParam) &&
      !searchParams.has(FacetFiltersForm.availabilityParam)
    ) {
      searchParams.set(
        FacetFiltersForm.availabilityParam,
        currentSearchParams.get(FacetFiltersForm.availabilityParam)
      );
    }

    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const currentSearchParams = new URLSearchParams(window.location.search);
    const nextSearchParams = new URLSearchParams(url);

    if (
      currentSearchParams.has(FacetFiltersForm.availabilityParam) &&
      !nextSearchParams.has(FacetFiltersForm.availabilityParam)
    ) {
      nextSearchParams.set(FacetFiltersForm.availabilityOptOutParam, '1');
    } else if (nextSearchParams.has(FacetFiltersForm.availabilityParam)) {
      nextSearchParams.delete(FacetFiltersForm.availabilityOptOutParam);
    } else if (currentSearchParams.get(FacetFiltersForm.availabilityOptOutParam) === '1') {
      nextSearchParams.set(FacetFiltersForm.availabilityOptOutParam, '1');
    }

    FacetFiltersForm.renderPage(nextSearchParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.availabilityParam = 'filter.v.availability';
FacetFiltersForm.availabilityOptOutParam = 'show_unavailable';
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

(function () {
  const updateShift = (label) => {
    const content = label.querySelector('.facet-tooltip__content');
    if (!content) return;
    label.style.setProperty('--tooltip-shift', '0px');
    const rect = content.getBoundingClientRect();
    const gutter = 8;
    const vw = document.documentElement.clientWidth;
    let shift = 0;
    if (rect.left < gutter) {
      shift = Math.round(gutter - rect.left);
    } else if (rect.right > vw - gutter) {
      shift = Math.round(vw - gutter - rect.right);
    }
    label.style.setProperty('--tooltip-shift', shift + 'px');
  };

  document.addEventListener('mouseover', (e) => {
    if (!e.target.closest) return;
    const label = e.target.closest('.facet-checkbox--tooltip');
    if (!label || label._tooltipHovered) return;
    label._tooltipHovered = true;
    updateShift(label);
  });

  document.addEventListener('mouseout', (e) => {
    if (!e.target.closest) return;
    const label = e.target.closest('.facet-checkbox--tooltip');
    if (!label) return;
    if (!label.contains(e.relatedTarget)) {
      label._tooltipHovered = false;
    }
  });
})();

(function () {
  const getSearchableList = (element) => element.closest('.facet-value-list--searchable');

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('.facet-list-search');
    if (!input) return;

    // Brand search is a local drawer interaction and must not submit filters.
    event.stopPropagation();

    const container = getSearchableList(input);
    if (!container) return;

    const query = input.value.trim().toLowerCase();
    const items = container.querySelectorAll('[data-facet-values] > li');
    let visibleItems = 0;

    items.forEach((item) => {
      const matches = !query || item.textContent.toLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) visibleItems += 1;
    });

    container.classList.toggle('is-searching', query.length > 0);

    const emptyMessage = container.querySelector('.facet-search-empty');
    if (emptyMessage) emptyMessage.hidden = visibleItems !== 0;
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.facet-list-toggle');
    if (!button) return;

    const container = getSearchableList(button);
    if (!container) return;

    const expanded = !container.classList.contains('is-expanded');
    container.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
  });
})();
